import { render, staticRenderFns } from "./ModalLocationCreate.vue?vue&type=template&id=bd175596"
import script from "./ModalLocationCreate.vue?vue&type=script&lang=js"
export * from "./ModalLocationCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports